import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Lightbulb } from "lucide-react";
import { SimilarItem } from "@/hooks/useDomainHierarchy";

interface SimilarItemSuggestionsProps {
  items: SimilarItem[];
  onSelect: (item: SimilarItem) => void;
  label: string;
}

export const SimilarItemSuggestions = ({ items, onSelect, label }: SimilarItemSuggestionsProps) => {
  if (items.length === 0) return null;

  return (
    <Card className="p-3 bg-muted/50 border-primary/20">
      <div className="flex items-start gap-2">
        <Lightbulb className="h-4 w-4 text-primary mt-0.5 flex-shrink-0" />
        <div className="flex-1">
          <p className="text-sm font-medium mb-2">Did you mean one of these existing {label}s?</p>
          <div className="flex flex-wrap gap-2">
            {items.map((item) => (
              <Button
                key={item.id}
                variant="outline"
                size="sm"
                onClick={() => onSelect(item)}
                className="text-xs"
              >
                {item.name}
                <span className="ml-1 text-muted-foreground">
                  ({Math.round(item.similarity_score * 100)}% match)
                </span>
              </Button>
            ))}
          </div>
        </div>
      </div>
    </Card>
  );
};
